export default __webpack_public_path__ + "static/trending-offers-background-84cfafdd25704f0dcbc92dcdb669391e.png";